export default function OneCredentialDelinkLogo() {
  return null;
}
